/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import _ from 'lodash';
import { FormHelperText, IconButton } from '@material-ui/core';
import images from 'assets/images';

export interface IFormikFileUploadProps {
    id?: string;
    name?: string;
    title?: string;
    className?: string;
    variant?: 'text' | 'outlined' | 'contained';
    color?: 'inherit' | 'primary' | 'secondary' | 'default';
    handleFileUpload?: (files: Array<any>) => void;
}

const FormikFileUpload = ({ field: { ...fields }, form: { errors }, ...props }): React.ReactNode => {
    const { id, name, title, className, handleFileUpload, ...rest }: IFormikFileUploadProps = props;
    const error = Boolean(_.get(errors, fields.name));
    const uploadInputRef = React.useRef(null);

    const handleFileUploadClick = () => {
        uploadInputRef.current && uploadInputRef.current.click();
    };

    const handleFileUploadChange = () => {
        if (handleFileUpload) handleFileUpload(uploadInputRef.current?.files);
    };

    return (
        <>
            <a className={className} onClick={handleFileUploadClick} title={title}>
                <input
                    {...rest}
                    id={id}
                    name={name}
                    type="file"
                    style={{ display: 'none' }}
                    ref={uploadInputRef}
                    multiple
                    onChange={handleFileUploadChange}
                />
                {title}
                <IconButton className="action-btn">
                    <img src={images.icUpload} alt="" />
                </IconButton>
            </a>
            {error && <FormHelperText error>{error && errors[fields.name]}</FormHelperText>}
        </>
    );
};
export default FormikFileUpload;
